export default class MembersMapController {
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/members-map/members-map.controller.js